module.exports = __webpack_public_path__ + "img/gjzs.55a74c02.png";